export const MODELS_TABLE_FORM = 'modelsTable';
